// Rating scales for the training diary (spec: 1–5 faces, RPE 1–10).
export const ENERGY = [
  { value: 1, emoji: '😫', label: 'Exhausted' },
  { value: 2, emoji: '😕', label: 'Tired' },
  { value: 3, emoji: '😐', label: 'OK' },
  { value: 4, emoji: '🙂', label: 'Good' },
  { value: 5, emoji: '😄', label: 'Full of energy' },
];

export const MOOD = [
  { value: 1, emoji: '😢', label: 'Very low' },
  { value: 2, emoji: '🙁', label: 'Low' },
  { value: 3, emoji: '😐', label: 'OK' },
  { value: 4, emoji: '🙂', label: 'Good' },
  { value: 5, emoji: '😁', label: 'Great' },
];

export const RPE_HINTS = {
  1: 'very easy', 2: 'easy', 3: 'moderate', 4: 'somewhat hard', 5: 'hard',
  6: 'hard', 7: 'very hard', 8: 'very hard', 9: 'extremely hard', 10: 'maximal',
};

// "Club routine" or "Club routine (skills 3–6)" for a routine tracking row.
export const routineLabel = (r) => (r.fromSkill != null ? `${r.name} (skills ${r.fromSkill}–${r.toSkill})` : r.name);

export const faceFor = (scale, value) => scale.find(s => s.value === value) || null;
